module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ARP – Attendee Reward Program","description":"Attendee Reward Program encourages Event Attendees to actively explore the event floor, participate in conversations with Exhibitors and automatically exchanges contact information between them.","short_name":"ARP","lang":"en","start_url":"/","background_color":"#ffffff","theme_color":"#ffffff","display":"minimal-ui","icon":"src/images/favicon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
